import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { cms } from 'assets/cms';

const StartPageWrapper = styled.div`
  /* margin-top: 50vh; */
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: space-between; */
  /* align-items: center; */
  /* margin-top: 20%; */
  margin: 150px auto;
  /* div { */
  /* width: 25%; */
  /* margin-left: 50px; */
  /* padding-top: 30px; */
  /* img { */
  /* height: 800px; */
  /* } */
  /* } */
  @media ${({ theme }) => theme.media.tablet} {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-item: center;
    flex-wrap: wrap;
    margin-top: 20%;
  }
`;
const ImgWrapper = styled.div`
  height: 250px;
  width: 250px;
  margin-left: 50px;
  padding-top: 30px;
  /* background-color: red; */

  /* img {
    height: 30%;
  } */
`;

const Images1 = styled.img`
  height: 60px;
`;
const ImagesLast = styled.img`
  height: 90px;
  margin-top: -25px;
`;

const StartPage = () => (
  <StartPageWrapper>
    <ImgWrapper>
      <Link to="/aboutus">
        <Images1 src={cms.logo.proj} />
        {/* <img src={cms.logo.proj} /> */}
        {/* </Images1> */}
      </Link>
    </ImgWrapper>
    <ImgWrapper>
      <Link to="/electromobility">
        <Images1 src={cms.logo.ele} />
      </Link>
    </ImgWrapper>
    <ImgWrapper>
      <Link to="/oze">
        <ImagesLast src={cms.logo.oze} />
      </Link>
    </ImgWrapper>
  </StartPageWrapper>
);

export default StartPage;
